// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1896":"9f30ded3","5514":"c154ab3a","8915":"e80da2aa"}[chunkId] + ".chunk.css";
};